module.exports = __webpack_public_path__ + "img/forgot-password.635ea6a0.jpg";